import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import MessengerCustomerChat from 'react-messenger-customer-chat';
import StaticPostLayout from '../components/StaticPostLayout';
import InfoSection from '../components/TripInfo/utah';
import MapSection from '../components/Maps/utah';

class UtahNationalParksRoadTrip extends Component {
  render() {
    return (
      <>
        <Helmet>
          <title>Utah National Parks Loop: 5-Day Scenic Road Trip Itinerary</title>
          <meta name="description" content="Plan the ultimate Utah National Parks loop in 5 days. Explore Zion, Bryce, Capitol Reef, Arches and Canyonlands with this scenic road trip itinerary." />
          <meta property="og:title" content="Utah National Parks Loop: 5-Day Scenic Road Trip Itinerary" />
          <meta property="og:description" content="Plan the ultimate Utah National Parks loop in 5 days. Explore Zion, Bryce, Capitol Reef, Arches and Canyonlands with this scenic road trip itinerary." />
          <meta property="og:url" content="https://exploroff.com/itineraries/utah-national-parks-road-trip" />
          <meta property="og:type" content="article" />
          <meta property="og:image" content="https://exploroff.com/img/utah-national-parks-road-trip/zion-narrows-bottom-up-.png" />
          <link rel="canonical" href="https://exploroff.com/itineraries/utah-national-parks-road-trip" />
          <script type="application/ld+json">{JSON.stringify({
            "@context": "https://schema.org", "@type": "BlogPosting",
            headline: "Utah National Parks Loop: 5-Day Scenic Road Trip Itinerary",
            description: "Plan the ultimate Utah National Parks loop in 5 days. Explore Zion, Bryce, Capitol Reef, Arches and Canyonlands.",
            image: ["https://exploroff.com/img/utah-national-parks-road-trip/utah-national-parks-road-trip.webp"],
            author: { "@type": "Organization", name: "ExplorOFF" },
            publisher: { "@type": "Organization", name: "ExplorOFF", logo: { "@type": "ImageObject", url: "https://exploroff.com/img/favicon.png" } },
            mainEntityOfPage: { "@type": "WebPage", "@id": "https://exploroff.com/itineraries/utah-national-parks-road-trip" }
          })}</script>
        </Helmet>
        <MessengerCustomerChat pageId="101590111335192" appId="695593052231950" />
        <StaticPostLayout
          title="Utah National Parks Loop: 5-Day Road Trip"
          category="itineraries"
          slug="utah-national-parks-road-trip"
          excerpt="Zion, Bryce Canyon, Capitol Reef, Arches, and Canyonlands in five days — the ultimate Utah road trip itinerary."
          tags={['planning', 'navigation', 'photography']}
          readTime={10}
          mapComponent={<MapSection />}
          whereToStay={[
            { name: 'Hotels in Springdale', type: 'Zion NP Gateway', url: 'https://www.booking.com/searchresults.html?ss=Springdale%2C+Utah' },
            { name: 'Bryce Canyon City Lodging', type: 'Bryce Canyon Gateway', url: 'https://www.booking.com/searchresults.html?ss=Bryce+Canyon+City%2C+Utah' },
            { name: 'Hotels in Moab', type: 'Arches & Canyonlands Gateway', url: 'https://www.booking.com/searchresults.html?ss=Moab%2C+Utah' },
          ]}
        >
          <InfoSection />
        </StaticPostLayout>
      </>
    );
  }
}

export default UtahNationalParksRoadTrip;
